import { PUNCH_CLOCK_VIEW, PUNCH_CLOCK_ADD } from '@/utils/permissions'

export default [
  {
    path: '/punch-clock/list',
    name: 'punch-clock-list',
    component: () => import('@/views/punch-clock/PunchClockList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Punch Clock List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Punch Clock List', active: true }
      ],
      permissions: [PUNCH_CLOCK_VIEW]
    }
  },
  {
    path: '/punch-clock/create',
    name: 'punch-clock-add',
    component: () => import('@/views/punch-clock/AddPunchClock.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Create Punch Clock',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Punch Clock List', url: '/punch-clock/list' },
        { title: 'Create Punch Clock', active: true }
      ],
      permissions: [PUNCH_CLOCK_ADD]
    }
  }
]
